import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Response } from 'express';
import { RESPONSE } from '../../express.tokens';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    @Optional() @Inject(RESPONSE) private response: Response,
    private router: Router
  ) {}

  public async redirectTo(
    path: string[],
    query?: { [key: string]: string },
    fragment?: string
  ): Promise<UrlTree | boolean> {
    if (isPlatformBrowser(this.platformId)) {
      await this.router.navigate(path, { queryParams: query, fragment, replaceUrl: true });
      return false;
    }

    let queryString = '';
    if (query) {
      queryString += '?';
      Object.entries(query).forEach(([key, value]) => {
        queryString += `${key}=${value}&`;
      });
      queryString = queryString.substring(0, queryString.length - 1);
    }

    this.response.redirect('/' + path.join('/') + queryString);
    return false;
  }

  public externalRedirectTo(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = url;
    } else {
      this.response.redirect(url);
    }
    return false;
  }
}
